module.exports = __webpack_public_path__ + "img/bottom_people_001_1.e9362953.svg";